import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { marked } from 'marked';
import ContentfulImage from '@moxy/react-contentful-image';
import _ from 'lodash';
import { withRouter, RouteComponentProps } from 'react-router';

import Button from 'client/components/button/button';
import { ContentfulImageType } from 'types/globals/contentful';
import { RouterType } from 'types/react-router';
import { Tracking } from 'web-core/src/tracking';

import { isProvisionedForBrand } from '../../utils';
import { WEB_CLICK_PARTNER_LANDING_PAGE } from '../../constants/tracking';

const mapStateToProps = ({ user, brand }) => ({
  brand,
  isLoggedIn: _.get(user, 'isLoggedIn', false),
  isProvisioned: isProvisionedForBrand(user, brand),
  user_id: _.get(user, 'oid', null),
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export type HeroExtraConfig = {
  cta: {
    label: string;
  };
  stats: {
    highlight: string;
    text: string;
  }[];
};

type Props = PropsFromRedux &
  RouteComponentProps & {
    router: RouterType;
    title: string;
    description: string;
    image: ContentfulImageType;
    extraConfig: HeroExtraConfig;
  };

const HeroSection = ({
  brand,
  isLoggedIn,
  location,
  router,
  extraConfig: { cta, stats },
  image,
  title,
  description,
}: Props) => {
  const markedData = description ? marked(description) : null;

  const clickHandler = () => () => {
    const { search } = location;

    if (isLoggedIn) {
      Tracking.track(WEB_CLICK_PARTNER_LANDING_PAGE, {
        type: 'logged-in',
        client: brand,
      });
      router.push({
        pathname: 'logged-in',
        search,
      });
    } else {
      Tracking.track(WEB_CLICK_PARTNER_LANDING_PAGE, {
        type: 'create',
        client: brand,
      });
      router.push({
        pathname: 'create',
        search,
      });
    }
  };

  return (
    <div className="hero-section row relative pad-top-2">
      <div className="column medium-8 large-7">
        <div className="left-column">
          <div className="pad-x-md">
            <h1>{title}</h1>
            <div dangerouslySetInnerHTML={{ __html: markedData }} />

            <div className="margin-top-3 max-w-456px">
              <Button className="primary margin-bottom" clickHandler={clickHandler()}>
                {cta.label}
              </Button>
            </div>
            <div className="info-row">
              {stats.map(({ highlight, text }) => (
                <div key={highlight} className="info">
                  <p className="total-info">{highlight}</p>
                  <p>{text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="column medium-4 large-5">
        <div className="right-column">
          <div className="flex-row center hide-for-small-only pad-top-2">
            <ContentfulImage
              className="hero-image"
              image={image.file.url}
              resize={{ width: 500 }}
              alt={image.title} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connector(withRouter(HeroSection));
